import React, { useMemo, useState } from "react";
import { Button, Col, Collapse, DatePicker, Form, Input, Row, Select, Space, Spin } from "antd";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../../..";
import { checkIsLoading, getSelectOptions, useActiveModal } from "../../../../lib/utils";
import "./TypesCharacteristicsListSearch.less";
import { BulkFiltersToggler } from "../../../../components/BulkFiltersToggler/BulkFiltersToggler";
import { searchIconForInput } from "../../../../lib/icons";
import { useTypesCharacteristicsContext } from "../../context/TypesCharacteristicsContext/TypesCharacteristicsContext";
import { ISearchFilterField } from "../../../../lib/types";

/* ------------------------------------------------------ Начало компонента ------------------------------------------------------ */

export const TypesCharacteristicsListSearch = () => {
  const {
    isSearchOpen,
    toggleSearchOpen,
    handleTypesCharacteristicsListSearch,
    typesCharacteristicsListSearchForm,
  } = useTypesCharacteristicsContext();

  const { typesCharacteristicsLoading } = useAppSelector((state) => state.typesCharacteristics);

  const dispatch = useAppDispatch();

  const allFields: ISearchFilterField[] = useMemo(
    () => [
      {
        label: "Наименование",
        fieldElement: (
          <Form.Item label="Наименование" name="name">
            <Input placeholder="Введите текст..." allowClear />
          </Form.Item>
        ),
        visible: true,
      },
      {
        label: "Alias",
        fieldElement: (
          <Form.Item label="Alias" name="aliases">
            <Input placeholder="Введите текст..." allowClear />
          </Form.Item>
        ),
        visible: true,
      },
      {
        label: "ID Типов характеристик",
        fieldElement: (
          <Form.Item
            label="ID Типов характеристик"
            name="charTypeIds"
            style={{ marginBottom: 0 }}
            className="form-item-required__hidden-error__mb0"
            labelCol={{ span: 11 }}
            wrapperCol={{ span: 13 }}
            rules={[
              {
                validator: (x, value) => {
                  if (value && /[^0-9,]/.test(value)) {
                    return Promise.reject();
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              aria-autocomplete="none"
              placeholder="Введите ID Типов характеристик через “,”"
              className="table-head-filter-search"
              allowClear
              suffix={searchIconForInput()}
            />
          </Form.Item>
        ),
        visible: false,
      },
    ],
    []
  );

  const [fields, setFields] = useState<ISearchFilterField[]>(allFields);

  return (
    <div className="types-characteristics-list-search">
      <Collapse
        expandIconPosition="right"
        activeKey={isSearchOpen ? "1" : ""}
        onChange={toggleSearchOpen}
      >
        <Collapse.Panel header="Расширенный поиск" key="1">
          <Row justify="end">
            <BulkFiltersToggler
              allFields={allFields}
              setFields={setFields}
              filterName="types-characteristics-list"
              minSave={["Наименование"]}
            />
          </Row>
          <Form
            form={typesCharacteristicsListSearchForm}
            onFinish={handleTypesCharacteristicsListSearch}
            wrapperCol={{ span: 17 }}
            labelCol={{ span: 7 }}
            labelAlign="left"
            onReset={() => {
              typesCharacteristicsListSearchForm.resetFields();
              // dispatch(typesCharacteristicsActions.cleanTypesCharacteristicsList());
            }}
          >
            <Row gutter={50}>
              {fields
                .filter(({ visible }) => visible)
                .map(({ fieldElement }, idx) => (
                  <Col span={8} key={idx}>
                    {fieldElement}
                  </Col>
                ))}
            </Row>
            <Row justify="end">
              <Space size={20}>
                <Button htmlType="reset">Очистить</Button>
                <Spin spinning={checkIsLoading(typesCharacteristicsLoading)}>
                  <Button type="primary" htmlType="submit">
                    Применить
                  </Button>
                </Spin>
              </Space>
            </Row>
          </Form>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};
